export default {
  global: {
    portal: 'HUB Facilitator Portal',
    logout: '退出',
  },
};
